export class ScreenOrder {
  constructor(
    public orderDate: Date,
    public orderedQuantity: number,
    public orderState: string = '',
    public paypalOrderDetail: any,
    public totalPrice: number
  ) {}
}
